import React from 'react';
import { Typography, useTheme } from '@mui/material';

import { TYPOGRAPHY_FONT_FAMILY_NAMES } from '../../typography';
import type {
  BaseTypographyVariant,
  ContentTypographyVariant,
} from '../../typography/TypographyType';

import type { TypographyProps } from '@mui/material';
import type { TypographyFontFamilyType } from '../../typography';

interface AIDTTypographyBaseProps
  extends Omit<TypographyProps, 'variant'> {
  fontFamily?: TypographyFontFamilyType;
  fontWeight?: number;
  fontSize?: string;
  lineHeight?: number;
}

/** typographyType: 'Content' | 'ContentClamp' 일 때만 title1, title2, body3, subtitle3, clampH1 등 Content 전용 variant 사용 가능 */
interface AIDTTypographyPropsWithContent extends AIDTTypographyBaseProps {
  typographyType: 'Content' | 'ContentClamp';
  variant?: ContentTypographyVariant;
}

interface AIDTTypographyPropsWithBase extends AIDTTypographyBaseProps {
  typographyType?: 'Default' | 'Fluid' | 'Clamp';
  variant?: BaseTypographyVariant;
}

type AIDTTypographyProps =
  | AIDTTypographyPropsWithContent
  | AIDTTypographyPropsWithBase;

const AIDTTypography: React.FC<AIDTTypographyProps> = ({
  fontFamily = 'pretendard',
  fontWeight,
  fontSize,
  lineHeight,
  children,
  typographyType,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Typography
      {...props}
      sx={{
        fontFamily: fontFamily
          ? TYPOGRAPHY_FONT_FAMILY_NAMES[fontFamily] ||
            theme.typography.fontFamily
          : theme.typography.fontFamily,
        fontWeight: fontWeight ?? theme.typography.body1.fontWeight,
        fontSize: fontSize ?? theme.typography.body1.fontSize,
        lineHeight: lineHeight ?? theme.typography.body1.lineHeight,
      }}
    >
      {children}
    </Typography>
  );
};

export default AIDTTypography;
